import { render, staticRenderFns } from "./WhiteRichText.vue?vue&type=template&id=5fa66e40"
import script from "./WhiteRichText.vue?vue&type=script&lang=ts"
export * from "./WhiteRichText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports